import React, { useEffect, useRef } from "react";
import "react-quill/dist/quill.snow.css";

export const RichTextToolBar = ({
  toolbarId,
}: {
  toolbarId: string;
}): JSX.Element => {
  const toolbarContainerRef: React.RefObject<HTMLDivElement> = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (toolbarContainerRef.current) {
        const container = toolbarContainerRef.current;
        const orderedListButton = container.querySelector(
          '.ql-list[value="ordered"]',
        ) as HTMLButtonElement | null;
        if (orderedListButton) {
          orderedListButton.setAttribute("title", "Ordered list");
        }

        const bulletListButton = container.querySelector(
          '.ql-list[value="bullet"]',
        ) as HTMLButtonElement | null;
        if (bulletListButton) {
          bulletListButton.setAttribute("title", "Bullet list");
        }

        const boldButton = container.querySelector(
          ".ql-bold",
        ) as HTMLButtonElement | null;
        if (boldButton) {
          boldButton.setAttribute("title", "Bold");
        }

        const italicButton = container.querySelector(
          ".ql-italic",
        ) as HTMLButtonElement | null;
        if (italicButton) {
          italicButton.setAttribute("title", "Italic");
        }

        const underlineButton = container.querySelector(
          ".ql-underline",
        ) as HTMLButtonElement | null;
        if (underlineButton) {
          underlineButton.setAttribute("title", "Underline");
        }

        const linkButton = container.querySelector(
          ".ql-link",
        ) as HTMLButtonElement | null;
        if (linkButton) {
          linkButton.setAttribute("title", "Insert link");
        }
      }
    }, 0);
  }, []);

  return (
    <div id={toolbarId} ref={toolbarContainerRef}>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
      </span>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-link" />
      </span>
      <span className="ql-formats">
        <button className="ql-clean" />
      </span>
    </div>
  );
};
